import {TabsContainer} from 'letrus-ui';
import {useEffect, useState} from 'react';
import {Highlight} from 'utils/hooks/useDraftAsTextHighlighter/useDraftAsTextHighlighter';
import debounce from 'utils/functions/debounce';
import AnnotationsTab from './AnnotationsTab';
import HighlightTab from './HighlightTab';
import styles from './WritingPreparationSidebar.module.scss';
import {sideBarViews} from '..';

enum SidebarTabs {
  highlight = 0,
  annotations = 1,
}

export interface WritingPreparationSidebarProps {
  highlightList?: Highlight[];
  deleteHighlight(selectedHighlight: Highlight): void;
  onChangeText(annotation: string): void;
  annotations?: string;
  openedView: sideBarViews;
  setOpenedView(view: sideBarViews): void;
}

function WritingPreparationSidebar({
  highlightList,
  deleteHighlight,
  onChangeText,
  annotations,
  openedView,
  setOpenedView,
}: WritingPreparationSidebarProps): JSX.Element {
  const [tabActive, setTabActive] = useState(0);

  const debouncedOnChangeText = debounce(onChangeText, 500);

  useEffect(() => {
    setTabActive(SidebarTabs[openedView]);
  }, [openedView]);

  const switchView = (tabActive: number) => {
    setTabActive(tabActive);

    if (tabActive === 0) {
      setOpenedView('highlight');
      return;
    }
    if (tabActive === 1) {
      setOpenedView('annotations');
      return;
    }
  };

  const tabs = [
    {
      title: 'Marcações',
      id: 0,
      children: (
        <div className={styles.tabsWrapper}>
          <HighlightTab
            highlightList={highlightList}
            deleteHighlight={deleteHighlight}
          />
        </div>
      ),
    },
    {
      title: 'Anotações',
      id: 1,
      children: (
        <div className={styles.tabsWrapper}>
          <AnnotationsTab
            annotationsEnabled
            annotations={annotations}
            onChangeText={(event) => debouncedOnChangeText(event.target.value)}
          />
        </div>
      ),
    },
  ];

  return (
    <div className={styles.writingPreparationSidebar}>
      <TabsContainer
        handleTabChange={switchView}
        tabActive={tabActive}
        tabs={tabs}
      />
    </div>
  );
}

export default WritingPreparationSidebar;
